import useIntro from "./Stores/useIntro"
import Forest from './Plots/00-Forest.jsx'
import Pond from './Plots/01-Pond.jsx'
import Garden from './Plots/02-Garden.jsx'
import Factory from './Plots/03-Factory.jsx'
import Lumberyard from './Plots/04-Lumberyard.jsx'
import PowerPlant from './Plots/05-PowerPlant.jsx'
import Apartment from './Plots/06-Apartment.jsx'
import Townhouses from './Plots/07-Townhouses.jsx'
import Houses from './Plots/08-Houses.jsx'
import Theater from './Plots/09-Theater.jsx'
import Restaurant from './Plots/10-Restaurant.jsx'
import Museum from './Plots/11-Museum.jsx'

import { Html } from "@react-three/drei"
import { useRef } from "react"

export default function SamplePlot(props) {
    const plotId = useIntro().plotNum
    const introState = useIntro()

    const popSound = new Audio('audio/01-pop.mp3')
    popSound.volume = .2
    

    const titles = [
        'Forest',
        'Pond',
        'Garden',
        'Factory',
        'Lumberyard',
        'Power Plant',
        'Apartment',
        'Townhouses',
        'Houses',
        'Theater',
        'Restaurant',
        'Museum',
    ]

    const descriptions = [
        '+$5 every 3 seconds',
        '+$3 every 3 seconds. +$2 more for each empty adjacent plot',
        '+$5 every 3 seconds',
        '+$2 every 3 seconds. +$10 more if developments > population',
        '+$12 every 3 seconds for each adjacent forest',
        '+$6 every 3 seconds for each adjacent power plant, factory, or lumberyard',
        '+15 population. -5 population for each adjacent power plant, factory, or lumberyard',
        '+10 population',
        '+5 population. +5 more population for each adjacent house, townhouse, or apartment',
        '+$1 every 3 seconds. +$5 more for each adjacent house, townhouse, or apartment',
        '+$1 every 3 seconds. +$1 more for each 5 population',
        '+$1 every 3 seconds. +$1 more for every 2 developments you built',
    ]

    const titleColors = [
        '#68BF12',
        '#3A79C4',
        '#C46C3A',
        '#C43AB6'
    ]

    function NextPlot() {
        introState.addPlotNum()
        popSound.play()
    }

    function PreviousPlot() {
        introState.subtractPlotNum()
        popSound.play()
    }

    return (<group>
        <Html center position={[props.position[0]+1.15,props.position[1],props.position[2]+1.55]}>
            <div className="plot-swapper">
                <button onClick={PreviousPlot}>Previous</button>
                <div className="swapper-content">
                    <div className="title">{titles[plotId]}</div>
                    <div className="description">{descriptions[plotId]}</div>
                </div>
                <button onClick={NextPlot}>Next</button>
            </div>
        </Html>
        {plotId == 0 ? <Forest position={props.position} built={false}/> : null}
        {plotId == 1 ? <Pond position={props.position} built={false} /> : null}
        {plotId == 2 ? <Garden position={props.position} built={false} /> : null}
        {plotId == 3 ? <Factory position={props.position} built={false} /> : null}
        {plotId == 4 ? <Lumberyard position={props.position} built={false} /> : null}
        {plotId == 5 ? <PowerPlant position={props.position} built={false} /> : null}
        {plotId == 6 ? <Apartment position={props.position} built={false} /> : null}
        {plotId == 7 ? <Townhouses position={props.position} built={false} /> : null}
        {plotId == 8 ? <Houses position={props.position} built={false} /> : null}
        {plotId == 9 ? <Theater position={props.position} built={false} /> : null}
        {plotId == 10 ? <Restaurant position={props.position} built={false} /> : null}
        {plotId == 11 ? <Museum position={props.position} built={false} /> : null}
    </group>)
}